// extracted by mini-css-extract-plugin
module.exports =  {"fadeInContainer":"fadeInContainer_RuAnZ2en","fadeIn":"fadeIn_C9CTuidU","switchLabel":"switchLabel_XLOCuKSd"};